import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom";
import { IWidgetComponent } from "./IWidgetComponent";
import { MsoTable } from "../../Table/MsoTable";
import { EditTypes } from "../../Table/EditTypes";
import { app } from "../../../Frame/App";
import { WidgetTable } from "../Widgets/WidgetTable";
import { IClientGridView } from "../../../Frame/GridViewSelect/IClientGridView";
import { GridViewSelect } from "../../../Frame/GridViewSelect";
import { LanguagesController } from "../../../Areas/Admin/Settings/Languages";
import { LanguageString } from "../../../Model/LanguageString";

export type WidgetTableComponentProps = {
    widget: WidgetTable;
    title: LanguageString;
    viewType: string;
}

export class WidgetTableComponent extends JSXComponent implements IWidgetComponent {
    props: WidgetTableComponentProps;

    constructor(props: WidgetTableComponentProps) {
        super(props);
    }

    public element: HTMLElement =
        <div className="widget Background-Blur-90-MSO">
            <div className="title-row">
                <div className="title mr-auto">{(this.props.title[`value${app.languageUpperCase}`] && this.props.title[`value${app.languageUpperCase}`].trim().length > 0) ? this.props.title[`value${app.languageUpperCase}`] : this.props.title[`value${app.defaultLanguageUpperCase}`]}</div>
                {this.renderGridViewSelect()}
            </div>
            <div className="content-row">
                {this.renderTable()}
            </div>
        </div>;

    renderTable(): HTMLElement {
        if (this.props.viewType) {
            let rootId = "widget_" + app.createGuid();
            let div: HTMLElement = <div id={rootId} className="mso-table" ></div >;

            let table = new MsoTable(div, {
                loadOnCreate: true,
                enableScroll: true,
                enableSort: true,
                enableFilterPopup: true,
                editType: EditTypes.MeasureFullscreen,
                viewType: this.props.viewType,
                viewIndex: 42,
                loadUrl: app.resolveUrl("~/api/tableView/get")
            });
            return div;
        }
        else {
            let div: HTMLElement = <div className="missing-props">{Resources["WidgetClient"].missingProps}</div>;
            return div;
        }
    }

    renderGridViewSelect(): HTMLElement {
        let div = <div></div>;
        $.get(app.resolveUrl(`~/api/gridView/getClientGridView/${this.props.viewType}/42/0`), (model: IClientGridView) => {
            const gridViewSelect = new GridViewSelect(div, model, true);
            gridViewSelect.onViewChanged = () => {
                gridViewSelect.closeDropdown();
                this.props.widget.recreate();
            };
        });
        return div;
    }

    public render(): HTMLElement {
        this.props.widget.setGridPosition();
        return this.element;
    }
}